import { IResult } from '../models/result-models';
import { PickupRequestDTO } from '../models/ups-pickup-request';
import { apiPost } from './api-utils';

const baseUrl = process.env.REACT_APP_SERVICES_URL + '/shipping/pickup';

export const submitUpsPickupRequest = async (
    upspickupequest: PickupRequestDTO
): Promise<IResult<string>> => {
    const result = await apiPost<PickupRequestDTO, string>(
        `${baseUrl}`,
        upspickupequest
    );
    return result;
};
